import { useMemo } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilState, useSetRecoilState } from "recoil";

import {
  PassengerMapControlsEnum,
  passengersMapCurrentPolylineViewAtom,
  passengersMapSelectedControlBtnAtom,
} from "@ryde/shared";

import { usePassengerMapSelectedStations } from "./use-passenger-map-selected-stations";

export const usePassengerMapSelectedControl = () => {
  const [passengersMapSelectedControlBtn, setPassengersMapSelectedControlBtn] =
    useRecoilState(passengersMapSelectedControlBtnAtom);

  const setPassengersMapCurrentPolylineView = useSetRecoilState(
    passengersMapCurrentPolylineViewAtom,
  );

  const { resetSelectedStation } = usePassengerMapSelectedStations();

  const filterStationControl = useMemo(() => {
    return {
      selected:
        passengersMapSelectedControlBtn ===
        PassengerMapControlsEnum.filterStations,
      disabled:
        passengersMapSelectedControlBtn &&
        passengersMapSelectedControlBtn !==
          PassengerMapControlsEnum.filterStations,
    };
  }, [passengersMapSelectedControlBtn]);

  const addNewStationControl = useMemo(() => {
    const isOneOfSelected = [
      PassengerMapControlsEnum.addOneNewStation,
      PassengerMapControlsEnum.addBulkNewStation,
    ].includes(passengersMapSelectedControlBtn as PassengerMapControlsEnum);

    return {
      selected: passengersMapSelectedControlBtn && isOneOfSelected,
      disabled: passengersMapSelectedControlBtn && !isOneOfSelected,
      selectedPanel:
        passengersMapSelectedControlBtn && isOneOfSelected
          ? passengersMapSelectedControlBtn
          : undefined,
    };
  }, [passengersMapSelectedControlBtn]);

  const linkStationsControl = useMemo(() => {
    return {
      selected:
        passengersMapSelectedControlBtn ===
        PassengerMapControlsEnum.linkStations,
      disabled:
        passengersMapSelectedControlBtn &&
        passengersMapSelectedControlBtn !==
          PassengerMapControlsEnum.linkStations,
    };
  }, [passengersMapSelectedControlBtn]);

  const handleControlClick = useEvent(
    (controlType: PassengerMapControlsEnum): void => {
      setPassengersMapCurrentPolylineView([]);
      if (
        !linkStationsControl.selected &&
        controlType === PassengerMapControlsEnum.linkStations
      ) {
        resetSelectedStation();
      }

      setPassengersMapSelectedControlBtn(prev =>
        prev === undefined ? controlType : undefined,
      );
    },
  );

  const resetSelectedControl = useEvent((): void => {
    setPassengersMapSelectedControlBtn(undefined);
  });

  return {
    filterStationControl,
    addNewStationControl,
    linkStationsControl,
    handleControlClick,
    resetSelectedControl,
  };
};
